export default "__VITE_ASSET__BlDCV5_f__"